/* [Component: storesImport] */
import { TStoreContext } from '../models/app/TStoreContext.js';

export function setupStoreContext(storeContext: TStoreContext) {
	/* [Component: stores] */
}
